import { action } from 'satcheljs';

// Should only be called to set the drag state for the addins view.
// This is used to set the drag state for the addins view when the user is dragging email items or attachments
// and dropping into the addins view.
// This is used to set pointer-events to none for the addins view when the user is dragging email items or attachments
export const setDragStateForAddinsView: (isDragging: boolean) => { isDragging: boolean } = action(
    'setDragStateForAddinsView',
    (isDragging: boolean) => ({ isDragging })
);
